import React from 'react'
import { styled } from 'styled-components'

const Container=styled.div`
    height:30px;
    background-image:"";
    background-color:#887dd1;
    color:white;
    margin:0;
    padding:10px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:14px;
    font-weight:500;  
    width: inherit;
`

const Announcement = () => {
  return (
    <Container>
      Super Deal! Free Shipping on arder over 2000 Rupee.
    </Container>
  )
}

export default Announcement
